import { ContentType } from '@creditsights/api-ui-web';
import { Widget } from '@creditsights/styleguide-web';
import isEmpty from 'lodash/isEmpty';
import React, { ReactElement } from 'react';
import classNames from 'classnames/bind';
import { createSearchParams, Link } from 'react-router-dom';
import { Tag } from '../../../models';
import { WIDGET_ID } from '../../../pages/Article/Article.constants';
import styles from './RelatedTopicsWidget.module.scss';
import { ROUTES } from '../../../Base.constants';
import { ContentTypeToSearchResultCategoryMap } from '../../../pages/SearchResults/SearchResults.constants';

const cx = classNames.bind(styles);

interface RelatedTopicsProps {
  relatedTopics: Tag[];
  contentType?: ContentType;
}

const RelatedTopicsWidget = ({ relatedTopics, contentType }: RelatedTopicsProps): ReactElement | null => {
  if (isEmpty(relatedTopics)) {
    return null;
  }

  return (
    <Widget headerTitle="Related Topics" dataTestId={WIDGET_ID.RELATED_TOPICS}>
      <div className={classNames(cx('body'), 'to-translate')}>
        {relatedTopics.map(({ name, tagId }) => (
          <div key={tagId} className={cx('topic')}>
            <Link
              key={`related-topic-${tagId}`}
              to={{
                pathname: ROUTES.search,
                search: createSearchParams({
                  searchTerm: name,
                  category: contentType ? ContentTypeToSearchResultCategoryMap[contentType] : '',
                }).toString(),
              }}
              data-testid="related-topic-item"
              className={cx('topic-link')}
            >
              {name}
            </Link>
          </div>
        ))}
      </div>
    </Widget>
  );
};

export default RelatedTopicsWidget;
